import { render, staticRenderFns } from "./UOMDropdownField.vue?vue&type=template&id=e4b459b0&scoped=true"
import script from "./UOMDropdownField.vue?vue&type=script&lang=js"
export * from "./UOMDropdownField.vue?vue&type=script&lang=js"
import style0 from "./UOMDropdownField.vue?vue&type=style&index=0&id=e4b459b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b459b0",
  null
  
)

export default component.exports